import { IdentityDto } from './../shared/identity.dto';
import { EntityDto } from './../entity/entity.dto';
import { AddressDto } from './address.dto';
import { EmailAddressDto } from './email-address.dto';
import { InstantMessengerDto } from './instant-messenger.dto';
import { PhoneNumberDto } from './phone-number.dto';

import { ContactPreferencesTypes } from '@nx-ws/bhn-enums/contact/preferences.enum';

export class ContactDto {
  entity = new EntityDto();
  identity = new IdentityDto();
  addresses: AddressDto[] = [];
  emailAddresses: EmailAddressDto[] = [];
  instantMessengers: InstantMessengerDto[] = [];
  phoneNumbers: PhoneNumberDto[] = [];

  preferences: ContactPreferencesTypes;
  webSite: string;
  types: string[];
  entityId: string;
  entityType: string;

  constructor(d?: ContactDto) {
    if (!d) {
      return;
    }

    this.preferences = d.preferences;
    this.webSite = d.webSite;
    this.types = d.types;
    this.entityId = d.entityId;
    this.entityType = d.entityType;
    this.identity = new IdentityDto(d.identity);
    this.entity = new EntityDto(d.entity);

    if (d.addresses) {
      this.addresses = d.addresses.map(a => new AddressDto(a));
    }
    if (d.emailAddresses) {
      this.emailAddresses = d.emailAddresses.map(e => new EmailAddressDto(e));
    }
    if (d.instantMessengers) {
      this.instantMessengers = d.instantMessengers.map(
        i => new InstantMessengerDto(i)
      );
    }
    if (d.phoneNumbers) {
      this.phoneNumbers = d.phoneNumbers.map(p => new PhoneNumberDto(p));
    }
  }
}
